export default function ProductDetailAlertPriceAfterApplyVoucher({
  text = '',
  condition = false,
  isProductDetail = false,
  style
}: {
  text: string;
  condition: boolean;
  isProductDetail?: boolean;
  style: React.CSSProperties
}) {
  if (!condition) return null;

  return <div style={{ margin: !isProductDetail ? '8px 0' : 0, fontStyle: 'italic', color: '#f5222d', ...style }}>{text || ''}</div>;
}
